export const formatNumber = (string) => {
	return isNaN(string)
		? "0"
		: parseInt(Math.round(string), 10).toLocaleString();
};
export const validateEmail = (mail) => {
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
		return true;
	}
	return false;
};
